import { CNavGroup, CNavItem } from '@coreui/react';
import { isMenuEnabled, isGameEnabled, isFeatureEnabled } from '../config/menuConfig';

/** 정산 관리 사이드바 블록 (admin / partner 경로 prefix만 다름) */
export const buildSettlementNavItems = (pathPrefix = '') => {
  if (!isFeatureEnabled('settlement')) {
    return [];
  }
  const settleBase = pathPrefix ? `${pathPrefix}/settle` : '/settle';
  return [
    {
      id: 50,
      component: CNavGroup,
      name: '정산 관리',
      to: settleBase,
      items: [
        {
          id: 52,
          component: CNavItem,
          name: '파트너 정산내역',
          to: `${settleBase}/partner-list1`,
        },
        {
          id: 53,
          component: CNavItem,
          name: '회원 정산내역',
          to: `${settleBase}/user-list`,
        },
        {
          id: 54,
          component: CNavItem,
          name: '게임별 정산 내역',
          to: `${settleBase}/game-list`,
        },
        {
          id: 55,
          component: CNavItem,
          name: '기간별 정산 내역',
          to: `${settleBase}/daily`,
        },
        {
          id: 56,
          component: CNavItem,
          name: '월 정산 내역',
          to: `${settleBase}/monthly`,
        },
      ],
    },
  ];
};

// 베팅 내역 메뉴 생성
export const createBettingMenus = () => {
  const menus = [];
  
  // 전체 베팅 내역 (항상 활성화)
  menus.push({
    id: 31,
    component: CNavItem,
    name: '배팅내역 조회',
    to: '/betting/list',
  });
  
  // 게임별 베팅 내역 (설정에 따라 활성화)
  if (isGameEnabled('sports')) {
    menus.push({
      id: 32,
      component: CNavItem,
      name: '스포츠 배팅내역',
      to: '/betting/sport/list',
    });
  }
  
  if (isGameEnabled('minigame')) {
    menus.push({
      id: 33,
      component: CNavItem,
      name: '미니게임 배팅내역',
      to: '/betting/minigame/list',
    });
  }
  
  if (isGameEnabled('casino')) {
    menus.push({
      id: 34,
      component: CNavItem,
      name: '카지노 배팅내역',
      to: '/betting/casino/list',
    });
  }
  
  if (isGameEnabled('slot')) {
    menus.push({
      id: 35,
      component: CNavItem,
      name: '슬롯 배팅내역',
      to: '/betting/slot/list',
    });
  }
  
  return menus;
};


// 미니게임 관리 메뉴 생성
export const createMinigameMenus = () => {
  const menus = [];
  
  if (!isGameEnabled('minigame')) {
    return menus; // 미니게임이 비활성화된 경우 빈 배열 반환
  }
  
  // 미니게임 마감시간 관리
  if (isMenuEnabled('minigame', 'close')) {
    menus.push({
      id: 61,
      component: CNavItem,
      name: "베팅 마감시간 관리",
      to: '/minigame/close'
    });
  }
  
  // 동행파워볼 관리
  if (isMenuEnabled('minigame', 'dhpowerball')) {
    const dhpowerballMenus = [];
    
    if (isMenuEnabled('minigame', 'dhpowerball', 'odds')) {
      dhpowerballMenus.push({
        id: 611,
        component: CNavItem,
        name: "배당 설정",
        to: '/minigame/dhpowerball/odds',
      });
    }
    
    if (isMenuEnabled('minigame', 'dhpowerball', 'setting')) {
      dhpowerballMenus.push({
        id: 613,
        component: CNavItem,
        name: "베팅 설정",
        to: '/minigame/dhpowerball/setting',
      });
    }
    
    if (isMenuEnabled('minigame', 'dhpowerball', 'result')) {
      dhpowerballMenus.push({
        id: 612,
        component: CNavItem,
        name: "경기 결과",
        to: '/minigame/dhpowerball/result',
      });
    }
    
    if (dhpowerballMenus.length > 0) {
      menus.push({
        id: 81,
        component: CNavGroup,
        name: "동행파워볼 관리",
        to: '/minigame/dhpowerball',
        items: dhpowerballMenus
      });
    }
  }
  
  // 동행파워사다리 관리
  if (isMenuEnabled('minigame', 'dhpowerladder')) {
    const dhpowerladderMenus = [];
    
    if (isMenuEnabled('minigame', 'dhpowerladder', 'odds')) {
      dhpowerladderMenus.push({
        id: 621,
        component: CNavItem,
        name: "배당 설정",
        to: '/minigame/dhpowerladder/odds',
      });
    }
    
    if (isMenuEnabled('minigame', 'dhpowerladder', 'setting')) {
      dhpowerladderMenus.push({
        id: 623,
        component: CNavItem,
        name: "베팅 설정",
        to: '/minigame/dhpowerladder/setting',
      });
    }
    
    if (isMenuEnabled('minigame', 'dhpowerladder', 'result')) {
      dhpowerladderMenus.push({
        id: 622,
        component: CNavItem,
        name: "경기 결과",
        to: '/minigame/dhpowerladder/result',
      });
    }
    
    if (dhpowerladderMenus.length > 0) {
      menus.push({
        id: 82,
        component: CNavGroup,
        name: "동행파워사다리",
        to: '/minigame/dhpowerladder',
        items: dhpowerladderMenus
      });
    }
  }
  
  return menus;
};

// 전체 메뉴 생성 함수
export const generateDynamicMenus = () => {
  return {
    betting: createBettingMenus(),
    minigame: createMinigameMenus(),
  };
};
